export function redirectToLegacy() {
    // This check prevents an infinite loop when running locally
    if (window.location.pathname === '/1') return
    window.location.href = '/1'
}
